import { render, staticRenderFns } from "./DialogTexEdit.vue?vue&type=template&id=17f594c2&scoped=true&lang=pug&"
import script from "./DialogTexEdit.vue?vue&type=script&lang=js&"
export * from "./DialogTexEdit.vue?vue&type=script&lang=js&"
import style0 from "./DialogTexEdit.vue?vue&type=style&index=0&id=17f594c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f594c2",
  null
  
)

export default component.exports